import { TFunction } from 'i18next';
import i18next from 'i18next';

export function getErrorResponseText(data: unknown): string {
  if (typeof data === 'string') {
    return data;
  }

  if (data && typeof data === 'object' && 'message' in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === 'string') {
      return message;
    }
  }

  return '';
}

type ResolveAuthErrorMessageOptions = {
  isLoginRequest?: boolean;
};

export function resolveAuthErrorMessage(
  status: number,
  responseText: string,
  options: ResolveAuthErrorMessageOptions = {},
  translate: TFunction = i18next.t.bind(i18next),
): string | null {
  const isLoginRequest = options.isLoginRequest ?? false;

  switch (status) {
    case 401:
      if (responseText.includes('User license expired or deactivated')) {
        return translate('Login.userLicenseExpiredOrDeactivated');
      }

      if (responseText.includes('No user license found')) {
        return translate('Login.noUserLicenseFound');
      }

      if (responseText.includes('Your email address has not been verified')) {
        return translate('Login.emailNotVerifiedWelcomeMail');
      }

      if (responseText.includes('Bad credentials')) {
        return translate('Login.badCredentials');
      }

      if (responseText.includes('Account has been deactivated.')) {
        return translate('Login.accountDeactivated');
      }

      if (responseText.includes('User is deactivated.')) {
        return translate('Login.userDeactivated');
      }

      if (isLoginRequest) {
        return translate('Login.incorrectUsernameOrPassword');
      }

      return null;

    case 402:
      if (responseText.includes('Account has been deactivated.')) {
        return translate('Login.accountDeactivated');
      }

      return null;

    case 403:
      if (
        responseText.includes(
          'Your account is temporarily locked due to multiple failed login attempts.',
        )
      ) {
        return translate('Login.accountLocked');
      }

      if (responseText.includes('User is deactivated.')) {
        return translate('Login.userIsDeactivated');
      }

      if (responseText.includes('Your email address has not been verified.')) {
        return translate('Login.emailNotVerified');
      }

      return null;

    case 409:
      if (isLoginRequest) {
        return translate('Login.userDeactivated');
      }

      return null;

    case 500:
      if (responseText.includes('Your session has timed-out.')) {
        return translate('Login.sessionTimedOut');
      }

      if (isLoginRequest) {
        return translate('Login.loginFailedTryAgain');
      }

      return null;

    default:
      return null;
  }
}

export function isLoginEndpointRequest(url: string): boolean {
  return url.includes('/loginEndpoint');
}
